var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9C0.9 9 0 8.1 0 7V2C0 0.9 0.9 0 2 0H10C11.1 0 12 0.9 12 2V7C12 8.1 11.1 9 10 9H8V12L5 9H2ZM20 15C21.1 15 22 14.1 22 13V8C22 6.9 21.1 6 20 6H14V7C14 9.2 12.2 11 10 11V13C10 14.1 10.9 15 12 15H14V18L17 15H20Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatlist);
export default __webpack_public_path__ + "static/media/chatlist.bf9a7d8d2f33cc11b4ac6c30ca266832.svg";
export { ForwardRef as ReactComponent };